import { appPaths } from "../../shared/routing/appPaths";

/**
 * The person's own pages (F79, P-E): one list, so the account menu and the profile tabs
 * offer the same pages under the same names (`profile.pages.<id>`).
 */
export const PROFILE_PAGES = [
  { id: "account", path: appPaths.profile(), end: true },
  { id: "preferences", path: appPaths.profilePreferences(), end: false },
  { id: "connectors", path: appPaths.profileConnectors(), end: false },
  { id: "memories", path: appPaths.profileMemories(), end: false },
] as const;

export type ProfilePageId = (typeof PROFILE_PAGES)[number]["id"];
